export default __webpack_public_path__ + "static/media/guard.89ea2913.mp4";